import React, { FC, useContext, useMemo } from 'react';
import { InvitesTable } from '../components/Invites/InvitesTable';
import { OrganizationInvitesFetcher } from '../fetchers/OrganizationInvitesFetcher';
import { PageHeader } from '../components/PageHeader/PageHeader';
import { useTranslation } from 'react-i18next';
import { EasyFilter } from '../components/EasyFilter/EasyFilter';
import { IQuickFiltersProps } from '../components/EasyFilter/QuickFilters';
import { FilteringContextProvider } from '../contexts/FilteringContext';
import { InviteButton } from '../components/Invites/InviteButton';

const CurrentOrganizationInvites: FC = () => {
  const { data, onRefresh } = useContext(OrganizationInvitesFetcher.Context);

  if (!data) return null;
  return <InvitesTable data={data.payload} onRefresh={onRefresh} />;
};

export const CurrentOrganizationInvitesPage: FC = () => {
  const { t } = useTranslation();

  const quickFilters = useMemo<IQuickFiltersProps['quickFilters']>(
    () =>
      new Map([
        [
          'Pending',
          {
            filterField: 'status',
            filterOp: 'equals',
            filterVal: 'PENDING',
            isDefault: true,
          },
        ],
      ]),
    [t]
  );
  return (
    <div>
      <PageHeader title={t('layout.navigation.invites')}>
        <InviteButton />
      </PageHeader>
      <FilteringContextProvider quickFilters={quickFilters}>
        <OrganizationInvitesFetcher.WAF>
          <EasyFilter quickFilters={quickFilters} />
          <CurrentOrganizationInvites />
        </OrganizationInvitesFetcher.WAF>
      </FilteringContextProvider>
    </div>
  );
};
